import React, { useState, useEffect } from "react";
import moment from "moment";
import { handleUnauthorized } from "../../utils/apiHelper";
import { formatApiDate } from "../../utils/dateHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { getGuestListDetail } from "../../services/guestListService";
import JoinedguestListLayer from "../JoinedGuestList/JoinedguestListLayer";

const formatDate = (dateStr) => formatApiDate(dateStr);

const formatPhone = (countrycode, phone) => {
  if (!phone) return "N/A";
  return countrycode ? `${countrycode} ${phone}` : phone;
};

const Field = ({ label, value }) => (
  <div className="col-md-3 mb-3">
    <label className="form-label fw-bold">{label}</label>
    <div>{value || "N/A"}</div>
  </div>
);

const PersonImage = ({ src, alt }) => {
  if (!src) return null;
  return (
    <div className="col-md-3 mb-3">
      <label className="form-label fw-bold">{alt}</label>
      <div>
        <img
          src={src}
          alt={alt}
          className="img-fluid rounded shadow-sm"
          style={{
            width: "100%",
            maxHeight: "180px",
            objectFit: "cover",
            cursor: "pointer",
          }}
          onClick={() => window.open(src, "_blank")}
        />
      </div>
    </div>
  );
};

const ViewGuestListPage = () => {
  const [guestData, setGuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("scan-list");

  useEffect(() => {
    const loadGuestList = async () => {
      if (!id) {
        setGuestData(null);
        setLoading(false);
        setErrorMessage("Guest list id is missing");
        return;
      }

      try {
        setLoading(true);
        const response = await getGuestListDetail(id);
        const payload = response?.data || {};
        const data = payload.data || payload.result || null;
        setGuestData(data);

        if (!data) {
          setErrorMessage("Guest list details not found");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      } catch (err) {
        if (err?.response?.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        setGuestData(null);
        setErrorMessage(
          err?.response?.data?.message || "Failed to fetch guest list details"
        );
        setTimeout(() => setErrorMessage(""), 3000);
      } finally {
        setLoading(false);
      }
    };

    loadGuestList();
  }, [id, navigate]);

  if (loading) return <Loader />;

  const promoter = guestData?.promoter;
  const hostId = guestData?.hostId || guestData?.host?._id || "";
  const promoterId = guestData?.promoterId || guestData?.promoter?._id || "";

  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {!guestData ? (
              <p>No data found.</p>
            ) : (
              <>
                <h6 className="fw-semibold mb-16">Guest List Details</h6>
                <div className="row">
                  <Field
                    label="Guest List Name"
                    value={guestData.guestListName || guestData.title}
                  />
                  <Field label="Title" value={guestData.title} />
                  <Field
                    label="Venue"
                    value={
                      guestData?.host?.businessName ||
                      guestData?.hostBusinessName ||
                      guestData?.hostName ||
                      "N/A"
                    }
                  />
                  <Field
                    label="Status"
                    value={
                      guestData.status ? (
                        <span className="text-capitalize">
                          {guestData.status}
                        </span>
                      ) : (
                        "N/A"
                      )
                    }
                  />
                  <Field
                    label="Created Date"
                    value={formatDate(guestData.createdAt)}
                  />
                  <Field
                    label="Joined Count"
                    value={
                      guestData.joinedCount != null
                        ? String(guestData.joinedCount)
                        : "N/A"
                    }
                  />
                  <Field
                    label="Scanned Count"
                    value={
                      guestData.scannedCount != null
                        ? String(guestData.scannedCount)
                        : "N/A"
                    }
                  />
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Description</label>
                    <div>{guestData.description || "N/A"}</div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {guestData && (
        <>
          <div className="col-md-12">
            <div className="card h-100">
              <div className="card-body p-24">
                <h6 className="fw-semibold mb-16">Promoter Details</h6>
                {promoter ? (
                  <div className="row">
                    <PersonImage
                      src={promoter.profilePicture}
                      alt="Profile Picture"
                    />
                    <Field label="Full Name" value={promoter.fullName} />
                    <Field label="Email" value={promoter.email} />
                    <Field
                      label="Phone"
                      value={formatPhone(promoter.countrycode, promoter.phone)}
                    />
                    <Field
                      label="Referral Code"
                      value={promoter.refralCode || promoter.referralCode}
                    />
                    <Field
                      label="Current Role"
                      value={
                        promoter.currentRole ? (
                          <span className="text-capitalize">
                            {promoter.currentRole}
                          </span>
                        ) : (
                          "N/A"
                        )
                      }
                    />
                    <Field
                      label="Verified Status"
                      value={
                        promoter.verifiedstatus ? (
                          <span className="text-capitalize">
                            {promoter.verifiedstatus}
                          </span>
                        ) : (
                          "N/A"
                        )
                      }
                    />
                    <Field
                      label="Status"
                      value={
                        promoter.status ? (
                          <span className="text-capitalize">
                            {promoter.status}
                          </span>
                        ) : (
                          "N/A"
                        )
                      }
                    />
                    <Field
                      label="Created Date"
                      value={formatDate(promoter.createdAt)}
                    />
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Address</label>
                      <div>{promoter.address || "N/A"}</div>
                    </div>
                  </div>
                ) : (
                  <p className="mb-0">No promoter details found.</p>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="card h-100 p-0 radius-12">
              <div className="card-header border-bottom bg-base p-0">
                <ul
                  className="nav border-gradient-tab nav-pills d-flex w-100 mb-0"
                  role="tablist"
                >
                  <li className="nav-item flex-fill text-center" role="presentation">
                    <button
                      type="button"
                      role="tab"
                      className={`nav-link w-100 d-flex align-items-center justify-content-center px-24 py-16 ${
                        activeTab === "scan-list" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("scan-list")}
                    >
                      Scan Guest List
                    </button>
                  </li>
                  <li className="nav-item flex-fill text-center" role="presentation">
                    <button
                      type="button"
                      role="tab"
                      className={`nav-link w-100 d-flex align-items-center justify-content-center px-24 py-16 ${
                        activeTab === "join-list" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("join-list")}
                    >
                      Join Guest  List
                    </button>
                  </li>
                </ul>
              </div>

              {activeTab === "scan-list" && (
                <JoinedguestListLayer
                  status="scanned"
                  viewBasePath="/scannedGuest"
                  hostId={hostId}
                  promoterId={promoterId}
                  hideHostFilter
                  hidePromoterFilter
                  hideVenueFilter
                  hideHostColumn
                  hideVenueColumn
                  hidePromoterColumn
                  hideGuestTitleColumn
                  hideCard
                  guestListId={id}
                />
              )}
              {activeTab === "join-list" && (
                <JoinedguestListLayer
                  status="joined,scanned"
                  viewBasePath="/joinedGuest"
                  hostId={hostId}
                  promoterId={promoterId}
                  hideHostFilter
                  hidePromoterFilter
                  hideVenueFilter
                  hideHostColumn
                  hideVenueColumn
                  hidePromoterColumn
                  hideGuestTitleColumn
                  hideCard
                  guestListId={id}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewGuestListPage;
